import React from 'react';
import PropTypes from 'prop-types';
import { getDomain } from '@src/tools/getDomain';

export const ClaimSearch = ({ radioValue, user, payer, provider, payers }) => {
  const domain = getDomain('sde-claims', 3200);
  const props = {
    isClaimTab: true,
    isClaimSearch: true,
  };

  return (
    <If condition={radioValue === 'claims'}>
      <abyss-parcel
        scriptdomain={domain}
        import='claims-claims-search@dev'
        stretch
        label='Claims Tab'
        showLoading
        loadingStyles={{ position: 'initial' }}
        props={JSON.stringify(props)}
        user={JSON.stringify(user)}
        payer={JSON.stringify(payer)}
        provider={JSON.stringify(provider)}
        payers={JSON.stringify(payers)}
      />
    </If>
  );
};

ClaimSearch.propTypes = {
  radioValue: PropTypes.string,
};

ClaimSearch.defaultProps = {
  radioValue: '',
};
